import {
  faCalendar,
  faCartShopping,
  faChartNetwork,
  faExchangeAlt,
  faIdCard,
  faMoneyBill,
  faMoneyBillTrendUp,
  faPhone,
} from '@fortawesome/pro-regular-svg-icons';
import {
  AllowancePeriod,
  CreditAccountType,
  FundLockType,
  IconListItem,
  SpendingCategory,
} from '@enrollhere/classes';
import { IconListItemA } from '../models';

export const creditAccountTypeMap: {
  [key: number]: Partial<IconListItem>;
} = {
  [CreditAccountType.CA_CREDIT]: {
    title: 'Credit Account',
    // icon: faCreditCard,
  },
};

export const creditAccountTypeList = [
  {
    ...creditAccountTypeMap[CreditAccountType.CA_CREDIT],
    id: CreditAccountType.CA_CREDIT,
  },
];

export const spendingCategoryMap: {
  [key: number]: Partial<IconListItemA>;
} = {
  [SpendingCategory.SC_DIALER]: {
    title: 'Dialer',
    icon: faPhone,
  },
  [SpendingCategory.SC_APPOINTMENTS]: {
    title: 'Appointments',
    icon: faCalendar,
  },
  [SpendingCategory.SC_LEAD_DATA_PURCHASE]: {
    title: 'Lead Data Purchases',
    icon: faIdCard,
  },
  [SpendingCategory.SC_LEAD_DATA_REQUEST]: {
    title: 'Lead Data Requests',
    icon: faCartShopping,
  },
  [SpendingCategory.SC_SIGNAL_360]: {
    title: 'EH Signal 360',
    icon: faChartNetwork,
  },
  [SpendingCategory.SC_TRANSFERS]: {
    title: 'Transfers',
    icon: faExchangeAlt,
  },
  [SpendingCategory.SC_REFUNDS]: {
    title: 'Refunds',
    icon: faMoneyBillTrendUp,
  },
  [SpendingCategory.SC_FEES]: {
    title: 'Fees',
    icon: faMoneyBill,
  },
};

export const lockTypeMap: { [key: string]: { name: string } } = {
  [FundLockType.FLT_COMMITMENT]: { name: 'Commitment' },
  [FundLockType.FLT_DISPUTE]: { name: 'Dispute' },
  [FundLockType.FLT_RESERVATION]: { name: 'Reservation' },
  [FundLockType.FLT_PERIOD_BLOCK]: { name: 'Period Block' },
  [FundLockType.FLT_SECURITY]: { name: 'Security' },
};

export const allowancePeriodMap: {
  [key: number]: { name: string; days: number };
} = {
  [AllowancePeriod.AP_ONE_TIME]: {
    name: 'One Time',
    days: 0,
  },
  [AllowancePeriod.AP_DAILY]: {
    name: 'Daily',
    days: 1,
  },
  [AllowancePeriod.AP_WEEKLY]: {
    name: 'Weekly',
    days: 7,
  },
  [AllowancePeriod.AP_MONTHLY]: {
    name: 'Monthly',
    days: 30,
  },
};
